export default __webpack_public_path__ + "static/blogImage-86649cb22acc4e14cb0742f4b8435d1f.svg";